// @flow

import { type Node } from 'react';

export function Empty(): Node {
  return null;
}
